var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-box',{attrs:{"h":"1vw"}},[(_vm.show)?_c('c-text',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }